import React from 'react';
import { InvisibleButton } from '../../../styles/common.styles';
import { SwitcherContainer } from './Switcher.styles';
import { blueDark02 } from '../../../styles/colors';

interface Props {
    clicked: boolean;
    id?: string;
    handleSwitch?: (id: string) => void;
    width: number;
    height: number;
    small?: boolean;
    stopPropagation?: boolean;
    iconColor?: string;
    iconColorActive?: string;
    bgColor?: string;
    bgColorActive?: string;
}
const Switcher: React.FC<Props> = ({
    clicked,
    id = '1',
    handleSwitch = () => {},
    width,
    height,
    small,
    stopPropagation = true,
    iconColor = blueDark02,
    iconColorActive = 'white',
    bgColor = 'white',
    bgColorActive = blueDark02
}) => {
    return (
        <SwitcherContainer 
            className="switch-mesh" 
            width={width} 
            height={height}
            iconColor={iconColor} 
            iconColorActive={iconColorActive}
            bgColor={bgColor}
            bgColorActive={bgColorActive}
        >
            <div className={`switch-container ${small && 'small'}`}>
                <InvisibleButton
                    onClick={(event) => {
                        if (stopPropagation) {
                            event.stopPropagation();
                        }
                        handleSwitch(id);
                    }}
                >
                    <div className={`switch-button th-head ${clicked ? 'clicked' : ''}`}></div>
                </InvisibleButton>
            </div>
        </SwitcherContainer>
    );
};

export default Switcher;
